import React from 'react';
import { FileText, Clock, CheckCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Card } from '../../ui';
import './ReportsKPICards.css';

export function ReportsKPICards({ kpis }) {
  const { t } = useTranslation();

  return (
    <div className="reports-kpi-cards">
      <Card className="reports-kpi-card" hoverable>
        <div className="reports-kpi-card__icon-container">
          <FileText size={24} className="reports-kpi-card__icon" />
        </div>
        <div className="reports-kpi-card__value">{kpis.totalReports}</div>
        <div className="reports-kpi-card__label">{t('reports.hub.kpis.totalReports')}</div>
      </Card>

      <Card className="reports-kpi-card" hoverable>
        <div className="reports-kpi-card__icon-container">
          <Clock size={24} className="reports-kpi-card__icon" />
        </div>
        <div className="reports-kpi-card__value">{kpis.reportsInProgress}</div>
        <div className="reports-kpi-card__label">{t('reports.status.in_progress')}</div>
      </Card>

      <Card className="reports-kpi-card" hoverable>
        <div className="reports-kpi-card__icon-container reports-kpi-card__icon-container--success">
          <CheckCircle size={24} className="reports-kpi-card__icon" />
        </div>
        <div className="reports-kpi-card__value">{kpis.completedReports}</div>
        <div className="reports-kpi-card__label">{t('reports.status.completed')}</div>
      </Card>
    </div>
  );
}
